import { DetailedHTMLProps, forwardRef, InputHTMLAttributes } from 'react'

type RadioButtonProps = DetailedHTMLProps<InputHTMLAttributes<HTMLInputElement>, HTMLInputElement>
const RadioButton = forwardRef<HTMLInputElement, RadioButtonProps>((props, ref) => {
  return (
    <input
      className="radio relative mr-2 h-5 w-5 cursor-pointer appearance-none rounded-full border-2
      border-stone-300 text-primary outline-none before:absolute before:left-1/2 before:top-1/2 before:h-[16px]
      before:w-[16px] before:-translate-x-1/2 before:-translate-y-1/2 before:rounded-full before:bg-white
      before:content-[''] checked:border-primary after:checked:absolute after:checked:left-1/2 after:checked:top-1/2 after:checked:z-10 after:checked:h-[12px] after:checked:w-[12px]
      after:checked:-translate-x-1/2 after:checked:-translate-y-1/2 after:checked:transform after:checked:rounded-full
      after:checked:bg-primary after:checked:content-[''] focus:shadow-none focus:outline-none"
      autoComplete="off"
      type="radio"
      id={props.name}
      value={props.value?.toString()}
      ref={ref}
      {...props}
    />
  )
})

export default RadioButton
